import get from 'lodash/fp/get';
import map from 'lodash/fp/map';
import find from 'lodash/fp/find';
import compact from 'lodash/fp/compact';
import uniq from 'lodash/fp/uniq';
import flow from 'lodash/fp/flow';

export const getAll = get('products.categories.items');

export const byId = (state, id) => flow(
  getAll,
  find({ id })
)(state);

export const getByIds = (state, ids) => flow(
  compact,
  uniq,
  map(id => byId(state, id)),
  compact,
)(ids);

export const getName = flow(
  byId,
  get('name'),
);

export const hasItems = state => get('products.categories.items.length', state) > 0;

const getUpdatedAt = get('products.categories.updatedAt');
const TEN_MINUTES_IN_MILLISECONDS = 600000;
export const shouldFetchItems = flow(
  getUpdatedAt,
  updatedAt => Date.now() - updatedAt > TEN_MINUTES_IN_MILLISECONDS,
);
